export const isAiDiscoverCommentsEnabled = false
